import React, { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import { useParams } from 'react-router-dom';

const STORE_URL = `${process.env.REACT_APP_SANDBOXVR_STORE_BASE_URL}/store_info`;
const DEVICES_URL = `${process.env.REACT_APP_SANDBOXVR_TV_BASE_URL}/devices`;

const fetchStore = async location => {
  return {
    result: 'Success',
    success: true,
    rooms: [
      {
        storeId: '21',
        operatorId: '1',
        storeCode: 'CNSHACEN',
        regionName: 'Shanghai',
        location: 'cnshacen',
        market: 'Shanghai',
        district: 'Huangpu',
        nickName: 'Central Plaza',
        entityName: '',
        address:
          'Room L2-12, 2nd Floor, No. 381 Huaihai Middle Road, Huangpu Qu, Shanghai Shi, China, 200436',
        roomId: 54,
        roomNumber: 1,
      },
      {
        storeId: '21',
        operatorId: '1',
        storeCode: 'CNSHACEN',
        regionName: 'Shanghai',
        location: 'cnshacen',
        market: 'Shanghai',
        district: 'Huangpu',
        nickName: 'Central Plaza',
        entityName: '',
        address:
          'Room L2-12, 2nd Floor, No. 381 Huaihai Middle Road, Huangpu Qu, Shanghai Shi, China, 200436',
        roomId: 55,
        roomNumber: 2,
      },
    ],
  };
};

export const fetchDevice = async (location, token) => {
  const result = await fetch(DEVICES_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ location }),
  });
  if (!result.ok) {
    const text = await result.text();
    throw new Error(`Fetch Devices Error: ${text}`);
  }
  const json = await result.json();
  return json;
};

let storeInfo = {};
let storeError = null;
let fetchPromise = {};
const useStoreInfo = (location, token) => {
  useEffect(() => {
    if (storeInfo[location]) return;
    if (fetchPromise[location]) return;
    fetchPromise[location] = Promise.all([fetchStore(location), fetchDevice(location, token)])
      .then(([store, devices]) => {
        storeInfo[location] = {
          store,
          devices,
        };
      })
      .catch(x => {
        storeError = x;
      });
  }, [location]);
  if (storeInfo[location]) return storeInfo[location];
  if (storeError) throw storeError;
  if (fetchPromise[location]) throw fetchPromise[location];

  return { store: { rooms: [] }, devices: [] };
};

const withStoreInfo = WrappedComponent => {
  const C = props => {
    const { location } = useParams();
    const { token } = useAuth();
    const storeInfo = useStoreInfo(location, token);
    return <WrappedComponent {...props} storeInfo={storeInfo} />;
  };
  C.displayName = `withStoreInfo(${WrappedComponent.displayName || WrappedComponent.name})`;
  return C;
};

export { useStoreInfo, withStoreInfo };
